import { useSyncExternalStore } from "react";

export function useMedia(query: string) {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(query);
      m.addEventListener("change", cb);
      return () => m.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
  );
}

/** phone < 768, tablet 768–1279, desktop ≥ 1280. */
export function useLayout(): "phone" | "tablet" | "desktop" {
  const md = useMedia("(min-width: 768px)");
  const xl = useMedia("(min-width: 1280px)");
  return xl ? "desktop" : md ? "tablet" : "phone";
}
